import * as v from 'valibot'

/**
 * h3live 身份交接：宿主登录用户换一枚 10 分钟内有效的 HS256 JWT，
 * 由 /live 页面 postMessage 给嵌入的 h3live iframe 验签。
 * @typedef {{ token: string, expires_in: number }} H3liveHandoffResponseT
 */
export const H3liveHandoffResponse = v.object({
  token: v.string(),
  expires_in: v.pipe(v.number(), v.integer(), v.minValue(1)),
})

/**
 * 一个直播间：宿主服务端从 h3live 公开接口整理成 snake_case；封面优先 poster_url，回落 cover_url。
 * @typedef {{ id: string, key: string, name: string, cover_url: string|null, poster_url: string|null, watching: number }} H3liveRoomT
 */
export const H3liveRoom = v.object({
  id: v.string(),
  key: v.pipe(v.string(), v.minLength(1)),
  name: v.string(),
  cover_url: v.nullable(v.string()),
  poster_url: v.nullable(v.string()),
  watching: v.pipe(v.number(), v.integer(), v.minValue(0)),
})

/**
 * 首页「换装直播间」区块与 /live 页面的数据：embed_origin 为空串表示本环境没接 h3live。
 * @typedef {{ embed_origin: string, channels: H3liveRoomT[] }} H3liveRoomsResponseT
 */
export const H3liveRoomsResponse = v.object({
  embed_origin: v.string(),
  channels: v.array(H3liveRoom),
})
